import { render, staticRenderFns } from "./RecycleDataSetTable.vue?vue&type=template&id=10962791&scoped=true"
import script from "./RecycleDataSetTable.vue?vue&type=script&lang=js"
export * from "./RecycleDataSetTable.vue?vue&type=script&lang=js"
import style0 from "./RecycleDataSetTable.vue?vue&type=style&index=0&id=10962791&prod&scoped=true&lang=css"
import style1 from "./RecycleDataSetTable.vue?vue&type=style&index=1&id=10962791&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10962791",
  null
  
)

export default component.exports